import { FC, useCallback } from "react";
import {
  Menu,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
  Persona,
  makeStyles,
} from "@fluentui/react-components";
import { SkanskaColorTokens } from "../../style/colors";
import useIsMobile from "../../hooks/useIsMobile";
import { useTranslation } from "react-i18next";
import { useGetMe } from "../../hooks/useUsers";
import { useMsal, MsalTokenService } from "@skanska/vsa-client-auth";

const useClasses = makeStyles({
  root: {
    cursor: "pointer",
  },
  persona: {
    color: SkanskaColorTokens.color_secondary_dim_black,
  },
  avatar: {
    backgroundColor: "lightgrey",
    marginRight: "10px",
    borderRadius: "50%",
  },
});

export const UserSettingsMenu: FC = () => {
  const classes = useClasses();
  const isMobile = useIsMobile();
  const { instance } = useMsal();
  const { t } = useTranslation();

  const onLogout = useCallback(() => {
    MsalTokenService.logoutAsync(instance);
  }, [instance]);

  const { data: me, isLoading: loadingMe } = useGetMe();
  const currentUser = instance.getActiveAccount();

  return (
    <div className={classes.root} role="button">
      <Menu>
        <MenuTrigger disableButtonEnhancement>
          <div>
            <Persona
              className={classes.persona}
              textPosition="after"
              size="extra-large"
              name={currentUser?.name}
              secondaryText={isMobile && !loadingMe ? me?.email : ""}
              textAlignment="center"
              avatar={{
                className: classes.avatar,
                image: {
                  src: !loadingMe ? me?.profilePhoto : "",
                },
              }}
            />
          </div>
        </MenuTrigger>
        <MenuPopover>
          <MenuList>
            <MenuItem data-testid="logOutMenuButton" onClick={onLogout}>
              {t("signOut")}
            </MenuItem>
          </MenuList>
        </MenuPopover>
      </Menu>
    </div>
  );
};
